import React from 'react';
import HTODisclaimer from 'components/HTODisclaimer';
import Link from 'next/link';
import Line from 'components/Line';
import Carousel from 'components/Carousel';
import NextSteps from 'components/NextSteps';
import Layout1x1 from 'components/Layout1x1';
import Layout3x1 from 'components/Layout3x1';
import StarRating from 'components/StarRating';
import SalesCalloutSwatches from 'components/SalesCalloutSwatches';
import SalesCalloutInspiration from 'components/SalesCalloutInspiration';
import Layout2x1ImageLeft from 'components/Layout2x1ImageLeft';
import Layout2x1ImageRight from 'components/Layout2x1ImageRight';
import Picture from 'components/Picture';
import DoubleHeader from 'components/typography/DoubleHeader';
import { withPageStaticProps } from 'utils/header';
import { GatedVideoEmbed } from 'components/Video';

/**
 * Custom widths for the source set of this page's hero image, to prevent
 * blurring when Imgix resizes it
 */
const heroImageWidths = {
  xl: 1440,
  lg: 1040,
  md: 880,
  sm: 660,
  xs: 660,
  base: 660,
};

class HIWWeddings extends React.PureComponent {
  render() {
    return (
      <>
        <div className="bg-gold-lighter py-1">
          <Layout1x1 className="m-section-hero" hero>
            <h1 className="text-h1-display">The Vows Collection</h1>

            <Picture
              url="https://gentux.imgix.net/1625255581_GTVCLPHero20210615020300.jpg"
              alt="Groom and Groomsmen in Allure Dark Blue Suit"
              srcSet={heroImageWidths}
              polaroid
            />
          </Layout1x1>
        </div>
        <Layout2x1ImageLeft
          className="m-section"
          image={
            <>
              <Carousel>
                <img
                  loading="lazy"
                  src="https://gentux.imgix.net/1625255741_GTVCLPABHero20210615020300.jpg?auto=format&w=376"
                  alt="Groom in Allure Light Gray Suit with bride"
                />
                <img
                  loading="lazy"
                  src="https://gentux.imgix.net/1625255740_GTVCLPABAlt320210615020300.jpg?auto=format&w=376"
                  alt="Groomsman in Allure Beige Suit with bridesmaid"
                />
                <img
                  loading="lazy"
                  src="https://gentux.imgix.net/1625255740_GTVCLPABAlt220210615020300.jpg?auto=format&w=376"
                  alt="Groomsmen in Allure Dark Blue Suit toasting"
                />
                <img
                  loading="lazy"
                  src="https://gentux.imgix.net/1625255740_GTVCLPABAlt120210615020300.jpg?auto=format&w=376"
                  alt="Bride and groom in Allure Dark Brown Suite"
                />
              </Carousel>
            </>
          }
        >
          <img
            src="https://gentux.imgix.net/1625586554_allurelogocropped210706114613.png?auto=format&w=200&dpr=2"
            width="200"
            alt="Generation Tux / Allure Bridals"
          />

          <Line />

          <p>
            Introducing the Vows collection from Generation Tux and Allure Bridals. A selection of four new suits designed in bold colors
            and constructed with comfort features so you look great, and feel great too. View the collection, build your look, and get
            everything shipped right to your door. Looking good has never been this easy.
          </p>

          <Link
            href="/collection/[category]"
            as="/collection/tuxedos-and-suits"
            className="tracker-cta-vows_collection-fall_2021-210706-113614 btn-info btn"
          >
            Suit & Tuxedo Collection
          </Link>
        </Layout2x1ImageLeft>
        <div className="p-section space-y-128 bg-gold-lighter">
          <Layout2x1ImageRight
            rowClassName="items-center"
            image={
              <Picture
                url="https://gentux.imgix.net/1625669399_GTVCLPCoolMaxHero20210706053000.jpg"
                alt="Allure Dark Blue Suit with tied tie"
                polaroid
              />
            }
          >
            <img
              src="https://gentux.imgix.net/1625589688_coolmaxsoronalogos.png?auto=format&width=243&dpr=2"
              width="243"
              alt="Coolmax and Sorona Logos"
            />
            <h2 className="text-h2">Fashion meets function.</h2>

            <p>
              The Vows collection was designed using Coolmax™ moisture wicking breathable fabric and Sorona™ stretch fiber construction for
              added comfort so you feel as good as you look on your wedding day.
            </p>
          </Layout2x1ImageRight>

          <Layout3x1
            block1={
              <div className="flex flex-col items-center space-y-8 text-center">
                <img
                  src="https://gentux.imgix.net/1625258309_GTVCLPBreathableIcon20210615103300.png?auto=format&w=80&h=80&fit=clamp&width=96&dpr=2"
                  width="80"
                  alt="Water Drop Icon"
                />
                <h3 className="text-h4">Stays Cooler</h3>
              </div>
            }
            block2={
              <div className="flex flex-col items-center space-y-8 text-center">
                <img
                  src="https://gentux.imgix.net/1625258311_GTVCLPFanIcon20210615103100.png?auto=format&w=80&h=80&fit=clamp&width=96&dpr=2"
                  width="80"
                  alt="Fan Icon"
                />
                <h3 className="text-h4">Feels Drier Against the Skin</h3>
              </div>
            }
            block3={
              <div className="flex flex-col items-center space-y-8 text-center">
                <img
                  src="https://gentux.imgix.net/1625258312_GTVCLPPerformanceIcon20210615103600.png?auto=format&w=80&h=80&fit=clamp&width=96&dpr=2"
                  width="80"
                  alt="Gauge Icon"
                />
                <h3 className="text-h4">Helps Ensure Consistent High Performance</h3>
              </div>
            }
          />
        </div>
        <div className="m-section space-y-64">
          <Layout2x1ImageLeft
            image={
              <div className="flex xs:justify-end">
                <img
                  src="https://gentux.imgix.net/1625586554_vowslogocropped210706114602.png?auto=format&w=180&dpr=2"
                  width="180"
                  alt="The Vows Collection"
                />
              </div>
            }
          >
            <h2 className="text-h2">The perfect suit, in 4 new colors</h2>
            <Line />
            <p>Choose your color and customize your wedding look with our interactive look builder.</p>
          </Layout2x1ImageLeft>

          <div className="container">
            <div className="row gap-y-32">
              <div className="col-span-6 space-y-16 md:col-span-3">
                <h4 className="text-h4">Allure Dark Blue Suit</h4>
                <img
                  src="https://gentux.imgix.net/1625255906_GTVCLPDarkBlueHero20210701043000.jpg?auto=format?w=800"
                  alt="Model in Allure Dark Blue Suit"
                />
                <Link
                  href="/collection/[category]/[slug]"
                  as="/collection/tuxedos-and-suits/allure-dark-blue-suit"
                  className="tracker-cta-vows_collection-collection_1-210706-113614 btn-info btn block w-full"
                >
                  View Product
                </Link>
              </div>

              <div className="col-span-6 space-y-16 md:col-span-3">
                <h4 className="text-h4">Allure Dark Brown Suit</h4>
                <img
                  src="https://gentux.imgix.net/1625255906_GTVCLPDarkBrownHero20210701062200.jpg?auto=format?w=800"
                  alt="Model in Allure Dark Brown Suit"
                />
                <Link
                  href="/collection/[category]/[slug]"
                  as="/collection/tuxedos-and-suits/allure-dark-brown-suit"
                  className="tracker-cta-vows_collection-collection_2-210706-113614 btn-info btn block w-full"
                >
                  View Product
                </Link>
              </div>

              <div className="col-span-6 space-y-16 md:col-span-3">
                <h4 className="text-h4">Allure Light Gray Suit</h4>
                <img
                  src="https://gentux.imgix.net/1625255907_GTVCLPLightGrayHero20210701054000.jpg?auto=format?w=800"
                  alt="Model in Allure Light Gray Suit"
                />
                <Link
                  href="/collection/[category]/[slug]"
                  as="/collection/tuxedos-and-suits/allure-light-gray-suit"
                  className="tracker-cta-vows_collection-collection_3-210706-113614 btn-info btn block w-full"
                >
                  View Product
                </Link>
              </div>

              <div className="col-span-6 space-y-16 md:col-span-3">
                <h4 className="text-h4">Allure Beige Suit</h4>
                <img
                  src="https://gentux.imgix.net/1625255905_GTVCLPBeigeHero20210702095400.jpg?auto=format?w=800"
                  alt="Model in Allure Beige Suit"
                />
                <Link
                  href="/collection/[category]/[slug]"
                  as="/collection/tuxedos-and-suits/allure-beige-suit"
                  className="tracker-cta-vows_collection-collection_4-210706-113614 btn-info btn block w-full"
                >
                  View Product
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gold-lighter py-1">
          <Layout2x1ImageLeft
            className="m-section"
            image={
              <Picture
                url="https://gentux.imgix.net/1625260901_GTVCLPSwatches20210615020300.jpg"
                className="aspect-ratio-7by5 xs:aspect-ratio-5by7"
                alt="Hand holding Sangria and Cinnamon swatches"
              />
            }
          >
            <DoubleHeader smallTitle={<h2>Swatches</h2>} largeTitle={<h3>Wedding planning made easy.</h3>} />

            <p>
              We want to help your wedding look perfect. Match your wedding look to your bridesmaids, wedding party, florals, linens, and
              more. Order free swatches from the Vows Collection so you can see the color and feel the quality from the comfort of your own
              home. We will deliver them to your door in 7-14 days.
            </p>
            <Link href="app/swatch/build" className="tracker-cta-vows_collection-swatches-210706-113614 btn-info btn">
              Order Swatches
            </Link>
          </Layout2x1ImageLeft>
        </div>
        <Layout2x1ImageRight
          className="m-section"
          image={
            <Picture
              url="https://gentux.imgix.net/1625261000_GTVCLPHTO20210615020300.jpg"
              className="aspect-ratio-7by5 xs:aspect-ratio-5by7"
              alt="Trying on the Allure Dark Brown Suit"
            />
          }
        >
          <h2>
            <DoubleHeader smallTitle="Home Try-On" largeTitle="Free home try-on for the wedding couple." />
          </h2>

          <Line />

          <p>
            Try the Vows Collection at home with a Generation Tux FREE Home Try-On. We'll send you a suit for you to experience the style
            and color from the comfort of your home, months before your big day.
          </p>
          <Link href="app/hto/looks/build" className="tracker-cta-vows_collection-hto-210706-113614 btn-info btn">
            Start Home Try-On
          </Link>
        </Layout2x1ImageRight>
        <div className="bg-gold-lighter py-1">
          <Layout1x1 className="m-section">
            <h2>
              <DoubleHeader smallTitle="Generation Tux/Allure Bridals" largeTitle="A partnership with your wedding in mind." />
            </h2>

            <GatedVideoEmbed>
              <iframe
                width="100%"
                height="330"
                src="https://www.youtube.com/embed/A-SnLzqK5PU?rel=0"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
              />
            </GatedVideoEmbed>

            <p>
              Generation Tux, delivering the highest quality suit and tuxedo rentals online since 2014 and Allure Bridals, a premier
              designer of wedding dresses and formal gowns, come together to create a collection of four suits that give you a timeless look
              for your wedding or any special occasion.
            </p>
          </Layout1x1>
        </div>
        <Layout3x1
          className="m-section"
          block1={
            <div className="flex flex-col space-y-16 bg-gold-lighter px-32 py-64">
              <h3 className="text-h5">Matt S.</h3>
              <StarRating rating={5} />
              <p className="text-gray-darker">
                “From the customer service to the quality of the tuxedos, Generation Tux delivers only the best. I have been in a number of
                weddings over the years and this company has the best quality yet.”
              </p>
            </div>
          }
          block2={
            <div className="flex flex-col space-y-16 bg-gold-lighter px-32 py-64">
              <h3 className="text-h5">Adam C.</h3>
              <StarRating rating={5} />
              <p className="text-gray-darker">
                “Exceeded expectations from Generation Tux. We were all thrilled with the quality of the product and the customer service
                was incredible.”
              </p>
            </div>
          }
          block3={
            <div className="flex flex-col space-y-16 bg-gold-lighter px-32 py-64">
              <h3 className="text-h5">Luke P.</h3>
              <StarRating rating={5} />
              <p className="text-gray-darker">
                “I absolutely loved this suit! The measuring process was online and spot on. The suit came packaged and wrapped. Looked
                absolutely incredible and was extremely comfortable! I would highly recommend Generation Tux!”
              </p>
            </div>
          }
        >
          <div className="space-y-16">
            <h2>
              <DoubleHeader smallTitle="Why rent with Generation Tux?" largeTitle="Here’s what real customers had to say..." />
            </h2>

            <Link href="/reviews" className="tracker-cta-vows_collection-reviews-210706-113614 btn-info btn">
              Read More Reviews
            </Link>
          </div>
        </Layout3x1>
        <div className="bg-gray-lighter py-1">
          <NextSteps
            ctaPageName="vows_collection"
            salesCallout1={<SalesCalloutSwatches ctaPageName="vows_collection" />}
            salesCallout2={<SalesCalloutInspiration ctaPageName="vows_collection" />}
          />
          <HTODisclaimer />
        </div>
      </>
    );
  }
}

export const getStaticProps = withPageStaticProps();

export default HIWWeddings;
